
if (typeof process !== 'undefined' && process.env.NODE_ENV === 'production') {
    module.exports = require('./mobx.min.js');
} else {
    module.exports = require('./mobx.js');
}
        


//////////////////
// WEBPACK FOOTER
// ./~/mobx/lib/index.js
// module id = 3264
// module chunks = 0